// Registry of toolbar SECTIONS contributed by slices. A host toolbar (floor-ui,
// later desktop-ui) exposes its DOM helpers as a SectionHost and mounts every
// registered section at a fixed spot in its layout; each section builds its own
// group and returns an optional render() the host calls inside its own render
// pass. A new sidebar section is then one register() call from the owning slice
// — no edits to the host toolbar's interfaces or render.
//
// Register before the host toolbar installs (mountAll runs once, at install).

export interface SectionHost {
  group(label?: string): HTMLElement; // a toolbar group container, appended to the bar
  button(parent: HTMLElement, text: string, onClick: () => void): HTMLButtonElement;
  subLabel(text: string): HTMLElement; // an uppercase sub-heading (caller appends)
}

export interface ToolbarSection {
  id: string;
  build(host: SectionHost): { render?: () => void } | void;
}

export interface SectionRegistry {
  register(section: ToolbarSection): void;
  mountAll(host: SectionHost): void; // host toolbar calls once at install
  renderAll(): void; // host toolbar calls inside its render()
}

export function createSectionRegistry(): SectionRegistry {
  const sections: ToolbarSection[] = [];
  const renderers: (() => void)[] = [];
  let mounted = false;
  return {
    register(section): void {
      if (mounted) throw new Error(`section "${section.id}" registered after mount`);
      sections.push(section);
    },
    mountAll(host): void {
      mounted = true;
      for (const s of sections) {
        const built = s.build(host);
        if (built?.render) renderers.push(built.render);
      }
    },
    renderAll(): void {
      for (const r of renderers) r();
    },
  };
}
